import isError from "lodash/isError";
import type { AnyAction } from "redux";
import type { Epic } from "redux-observable";

import { Logger } from "~/tools/logger";
import { EMPTY, catchError, flatMap, from, map, of } from "~/tools/rxjs";

import { deprovision } from "../../../../backend/StackPacksApi";
import { ofType } from "../../../../generic/redux/TypedRedux";
import {
	type DeprovisionStackPack,
	type DeprovisionStackPackError,
	type DeprovisionStackPackSuccess,
	deprovisionStackPackError,
	deprovisionStackPackSuccess,
} from "../../pages/stackPacks/details/StackPacksDetailsActions";
import { STACK_PACKS_DEPROVISION_START } from "../../pages/stackPacks/details/StackPacksDetailsActionTypes";
import type { EpicDependencies } from "../../ReduxStore";
import type { RootState } from "../../RootState";

const logger = Logger.namespace("StackPacksDeprovisionEpic");

type Response = DeprovisionStackPackSuccess | DeprovisionStackPackError;

export const StackPacksDeprovisionEpic: Epic<AnyAction, Response, RootState, EpicDependencies> = (actions) =>
	actions.pipe(
		ofType(STACK_PACKS_DEPROVISION_START),
		flatMap(({ stackPack, configurationId, retry }: DeprovisionStackPack) =>
			from(deprovision(stackPack, configurationId!, retry)).pipe(
				map(() => deprovisionStackPackSuccess(stackPack, configurationId)),
				catchError((error: unknown) => {
					if (!isError(error)) {
						return EMPTY;
					}

					logger.error(error);
					return of(deprovisionStackPackError(stackPack, configurationId, error));
				}),
			),
		),
	);
